import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { UPDATE_ARTICLES_FACEBOOK_PAGE_MUTATION } from './updateArticlesFacebookPage.mutation';
import {
  UpdateArticlesFacebookPageMutation,
  UpdateArticlesFacebookPageMutationVariables
} from './__generated__/UpdateArticlesFacebookPageMutation';

// No onError here: the Set Facebook Page dialog awaits the promise and reports errors itself.
export const useUpdateArticlesFacebookPageMutation = () =>
  useMutation<UpdateArticlesFacebookPageMutation, UpdateArticlesFacebookPageMutationVariables>(
    UPDATE_ARTICLES_FACEBOOK_PAGE_MUTATION,
    { client: kmsClient }
  );
